export const OnboardingAgeInformation = () => null
